import LeaguePlayerIndex from './LeaguePlayerIndex';
import LeaguePlayerCreate from './LeaguePlayerCreate';
import LeaguePlayerSettings from './LeaguePlayerSettings';
import LeaguePlayerSingle from './LeaguePlayerSingle';

export default function (app) {

    const settings = LeaguePlayerSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeaguePlayerIndex(app, settings);

    LeaguePlayerCreate(app, settings);

    LeaguePlayerSingle(app, settings);

}